import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertService } from '../services/alert/alert.service';
import { ToastService } from '../services/toast/toast.service';
import { ApiService } from '../services/api/api.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-otp',
  templateUrl: './otp.page.html',
  styleUrls: ['./otp.page.scss'],
})
export class OtpPage implements OnInit {
  mobile_no:any = ''
  OTPdata = {
    otp_no1: '',
    otp_no2: '',
    otp_no3: '',
    otp_no4: '',
    otp_no5: '',
    otp_no6: ''
}

  otp_number_temp:any = ''
  countryCode: any = '91'
  constructor(private router: Router,public alert: AlertService,public toast: ToastService,public api: ApiService) { }

  ngOnInit() {
    this.countryCode = localStorage.getItem("country_code")
    this.mobile_no = localStorage.getItem("phone_no")
    if(JSON.parse(this.countryCode) == 91){
      this.otp_number_temp = JSON.parse(localStorage.getItem("otp"))
      this.otp_number_temp = this.otp_number_temp.toString().split('').map((iNum:any) => parseInt(iNum, 10));
      
      this.OTPdata.otp_no1 =  this.otp_number_temp[0]
      this.OTPdata.otp_no2 =  this.otp_number_temp[1]
      this.OTPdata.otp_no3 =  this.otp_number_temp[2]
      this.OTPdata.otp_no4 =  this.otp_number_temp[3]

      setTimeout(()=>{
        this.verifyOTP()
      },500)
  }

  }

  // autoFill(event:any){
  //   console.log(event.target.value)
  //   if(event.target.value){
  //     let otp:any = JSON.stringify(JSON.parse(event.target.value))
  //     if(otp.length == 4){
  //       for (var i = 0, len = otp.length; i < len; i += 1) {
  //         if(i == 0){
  //           this.OTPdata.otp_no1 = otp.charAt(i)
  //         }
  //         else if(i == 1){
  //           this.OTPdata.otp_no2 = otp.charAt(i)
  //         }
  //         else if(i == 2){
  //           this.OTPdata.otp_no3 = otp.charAt(i)
  //         }
  //         else if(i == 3){
  //           this.OTPdata.otp_no4 =  otp.charAt(i)
  //         }
  //       }
  //     }
  //   }
  // }

      /**
     * OTP number focus movement
     */
    moveFocus(value,nextElement) {
      nextElement.setFocus();
    }
  //   moveFocus(value, nextElement) {
  //     if (nextElement) {
  //         if (value) {
  //             if (!nextElement._value) {
  //                 nextElement.setFocus();
  //             }
  //         }
  //     }
  // }

  verifyOTP(){
    //Validating OTP Number
    if (this.OTPdata) {
      let num = this.OTPdata.otp_no1 + this.OTPdata.otp_no2 + this.OTPdata.otp_no3 + this.OTPdata.otp_no4; 
      // + this.OTPdata.otp_no5 + this.OTPdata.otp_no6;
      if (num) {
          if (num.length < 4 || num.length == 0) {
              this.alert.presentAlert('Invalid OTP','',"Please enter the OTP");
              return;
          } else {
            let requestData:any = {
              "country_code": this.countryCode,
              "mobile": this.mobile_no,
              "request_channel":"sms",
              "otp_number": num
              }
      
            this.api.verifyOTP(requestData).subscribe(async(result:any) => {
              if(result.status == true){
                this.toast.presentToast("OTP verified successfully")
                localStorage.setItem('token',result.data.token)
                let navigateToPage:any = localStorage.getItem('previouspage')
                if(navigateToPage != '' && navigateToPage != undefined && navigateToPage != null){
                    let id = localStorage.getItem('store_id')
                    this.router.navigate(['/home/'+id])
                    // this.router.navigate(['/'+navigateToPage])
                }
                else{
                  let id = localStorage.getItem('store_id')
                  this.router.navigate(['/home/'+id])
                }
              }
              else{
                this.alert.presentAlert('Invalid OTP','','Please enter the valid OTP')
              }
            },(err)=>{
              this.alert.presentAlert('Invalid OTP','','Please enter the valid OTP')
              console.log(err)
            });
            
            }
          }
      }
    }

  resend(){
    let requestData:any = {
      "country_code": this.countryCode,
      "mobile": this.mobile_no,
      "request_channel": "sms"
    }

    this.api.generateOTP(requestData).subscribe(async(result:any) => {
      if(result.status == true){
        this.toast.presentToast("OTP sent successfully")
      }
      else{
        this.alert.presentAlert('Alert','',result.message);
      }
    },(err)=>{
      console.log(err)
    });

  }

}
